import { Directive, ElementRef, inject, Input, OnDestroy, OnInit, afterNextRender, effect, NgZone } from '@angular/core';
import { NgControl, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[inputRequired]',
  standalone: false,
})
export class InputRequiredDirective implements OnInit, OnDestroy {
  private control = inject(NgControl, { optional: true });
  private el = inject(ElementRef);
  private ngZone = inject(NgZone);
  private statusSub?: Subscription;

  // Sử dụng effect thay cho afterNextRender
  private readonly renderEffect = effect(() => {
    this.updateValidationState();
  });

  ngOnInit() {
    if (!this.control) {
      console.warn('BootstrapValidationDirective requires NgControl');
      return;
    }

    this.statusSub = this.control.statusChanges?.subscribe(() => {
      this.ngZone.run(() => {
        this.updateValidationState();
      });
    });

    // Cập nhật trạng thái ban đầu
    this.updateValidationState();
  }

  private updateValidationState() {
    const nativeElement = this.el.nativeElement;
    if (this.control?.invalid && (this.control?.dirty || this.control?.touched)) {
      nativeElement.classList.add('is-invalid');
      nativeElement.classList.remove('is-valid');
    } else if (this.control?.valid && (this.control?.dirty || this.control?.touched)) {
      nativeElement.classList.add('is-valid');
      nativeElement.classList.remove('is-invalid');
    } else {
      nativeElement.classList.remove('is-valid', 'is-invalid');
    }
  }

  ngOnDestroy() {
    this.statusSub?.unsubscribe();
  }
}
